import { getFirestore, collection, query, where, getDocs, setDoc, doc, getDoc, addDoc } from "firebase/firestore";
import { Firebase_App } from "./firebase";

export const db = getFirestore(Firebase_App)

export async function getDocumentsWithPrefix(collectionName: string, prefix: string) {
  const startAt = prefix;
  
  // '\uf8ff' is a high Unicode character to ensure the query includes all documents starting with the prefix
  const endAt = prefix + '\uf8ff'; 

  // Query the collection
  const q = query(
    collection(db, collectionName),
    where("__name__", ">=", startAt),
    // where("__name__", "<", endAt)
  );

  try {
    const querySnapshot = await getDocs(q);
    const documents = querySnapshot.docs.map(doc => ({
      id: doc.id,
      data: doc.data()
    }));
    
    return documents;
  } catch (error) {
    console.error("Error fetching documents with prefix: ", error);
    return [];
  }
}

/**
 * @deprecated
 */
export async function getDocumentById(collectionName, documentId) {
  const docRef = doc(db, collectionName, documentId);
  const docSnap = await getDoc(docRef);
  return docSnap.data()
}

export async function loadDocumentFromStore(collectionName, docId) {
    
  const docRef = doc(db, collectionName, docId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data(); 
  } else {
    return null
  }
}

export async function saveDocumentToStore(id, collectionName, data) {
  await setDoc(doc(db, collectionName, id), data);
}

export async function createDocumentInStore(collectionName, data) {
  return await addDoc(collection(db, collectionName), data);
}

export function autoGenerateDocumentId() {
  const collectionRef = collection(db, "docs");
  const newDocRef = doc(collectionRef);
  return newDocRef.id;
}
